export type StepConfig = {
  path: string;
  private?: boolean;
  requirements?: StepRequirement[];
  relativePath?: boolean;
};

export type FlowConfig = Record<string, StepConfig>;

export interface FlowMap {
  hybrid: FlowConfig;
  bundleSelection: FlowConfig;
  instantInk: FlowConfig;
  unknown: FlowConfig;
}

export enum FlowType {
  Pc = 'hybrid',
  Printer = 'bundleSelection',
  InstantInk = 'instantInk',
  Unknown = 'unknown',
}

export type StepParams = {
  pdpConfig?: { skus: string; pdpFlow: string; isSMB?: string };
  cart?: { id: string };
  claim?: { cartId: string };
  orderComplete?: { id: string };
  [key: string]: Record<string, string> | undefined;
};

export type StepRequirement =
  | 'hasIISubscription'
  | 'isLoggedIn'
  | 'redirectToClaim'
  | 'hasMoreThanOneTenant'
  | 'goToPrinterSelection';

export type Requirements = Record<StepRequirement, boolean>;
